var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarksActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87518 6C8.83993 6 8 6.83993 8 7.87518V25.0643C8 25.4159 8.19533 25.7363 8.50786 25.8965C8.82039 26.0566 9.19543 26.0293 9.48061 25.8261L15.5007 21.5288L21.5208 25.8261C21.806 26.0293 22.1811 26.0566 22.4936 25.8965C22.8061 25.7363 23.0015 25.4159 23.0015 25.0643V7.87518C23.0015 6.83993 22.1615 6 21.1263 6H9.87518Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarksActive);
export default __webpack_public_path__ + "static/media/bookmarks-active.8587afa0a4bd1ad865b9320313fcfd75.svg";
export { ForwardRef as ReactComponent };